// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__ZlPPQ","active":"Tabs_active__qx7nv","conteudo":"Tabs_conteudo__SFsBh"};